import React from 'react';
import get from 'lodash/get';
import PeopleIcon from 'assets/icon-user';
import ResponsiveImage from 'components/common/ResponsiveImage';
import BlockDescription from 'components/BlockDescription';
import { SkeletonLine } from 'components/theme/Skeleton';
import { useTranslation } from 'react-i18next';
import {
  ExperiencesBodyHost,
  Title4,
  HostedBy,
  HostedByImageWrap,
  HostedByImage,
  DefaultUserAvatar,
  HostDescription,
  DescriptionSkeleton,
} from './styles';

interface IHostedBy {
  firstName?: string;
  lastName?: string;
  description?: string;
  profilePicture?: {
    uri?: string;
  };
}

interface IExperience {
  loading: boolean;
  hostedBy?: IHostedBy;
  isNoHost?: boolean;
}

interface ExperienceHostProps {
  experience: IExperience;
  hostName: string;
  isHostLed: boolean;
  isLoadingListing: boolean;
  isSquare: boolean;
  onImgLoad: (event: React.SyntheticEvent<HTMLImageElement>) => void;
  userProfileImage: string;
}

const ExperienceHost: React.FC<ExperienceHostProps> = ({
  experience,
  hostName,
  isHostLed,
  isLoadingListing,
  isSquare,
  onImgLoad,
  userProfileImage,
}) => {
  const { t: translate } = useTranslation();
  if (!isHostLed) return null;
  return (
    <ExperiencesBodyHost>
      {!experience.loading ? (
        <Title4
          as={'h3' as const}
          className="experience-view__experience-section-title"
        >
          {translate('hostedBy')} {get(experience, 'hostedBy.firstName')}
        </Title4>
      ) : (
        <SkeletonLine />
      )}

      <HostedBy>
        {userProfileImage ? (
          <HostedByImageWrap>
            {!experience.loading ? (
              <ResponsiveImage
                uriObject={userProfileImage}
                defaultSize="48w"
                isSquare={isSquare}
                onLoad={onImgLoad}
                CustomRenderer={HostedByImage}
                alt={`${translate('photoOf')} ${hostName}`}
                viewType="small"
              />
            ) : (
              <SkeletonLine />
            )}
          </HostedByImageWrap>
        ) : (
          (!experience.loading && (
            <DefaultUserAvatar>
              <PeopleIcon />
            </DefaultUserAvatar>
          )) || <SkeletonLine />
        )}

        {!experience.loading || !isLoadingListing ? (
          <HostDescription>
            <BlockDescription
              description={get(experience, 'hostedBy.description')}
              showReadMore
              shortDescriptionLength={450}
            />
          </HostDescription>
        ) : (
          <DescriptionSkeleton>
            <SkeletonLine />
          </DescriptionSkeleton>
        )}
      </HostedBy>
    </ExperiencesBodyHost>
  );
};

export default ExperienceHost;
